import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";

function VerticallyCenteredModal(props) {
  const history = useHistory();
  const { onHide, data } = props;
  const { users } = useSelector((states) => states.auth);

  return (
    <div className="modal-card">
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body
          style={{
            width: "100%",
            height: "100%",
            maxHeight: "65vh",
            display: "flex",
            gap: "20px",
            overflowY: "scroll",
          }}
        >
          <div style={{ width: "75%", overflow: "hidden" }}>
            <img
              src={data?.image}
              alt="Gambar produk"
              style={{ margin: "auto", maxWidth: "100%", borderRadius: "10px" }}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "30px",
            }}
          >
            <div>
              <h4
                style={{
                  color: "var(--Mono-Black, var(--text, #2D2D2D))",
                  fontFamily: "Open Sans",
                  fontSize: "24px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "180%",
                }}
              >
                {data?.name}
              </h4>
              <div
                style={{ display: "flex", gap: "20px", alignItems: "center" }}
              >
                {data?.priceDiscount !== "" &&
                parseInt(data?.priceDiscount) !== 0 ? (
                  <>
                    <h3
                      style={{
                        color: "var(--Gray-3, #828282)",
                        fontFamily: "Open Sans",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "180%",
                        textDecoration: "line-through",
                      }}
                    >
                      <NumberFormat
                        prefix={"Rp "}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        displayType="text"
                        value={data?.price}
                      />
                    </h3>
                    <h3
                      style={{
                        color: "var(--Red, #EB5757)",
                        fontFamily: "Open Sans",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        lineHeight: "180%",
                      }}
                    >
                      <NumberFormat
                        prefix={"Rp "}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        displayType="text"
                        value={data?.priceDiscount}
                      />
                    </h3>
                  </>
                ) : (
                  <h3
                    style={{
                      color: "var(--Gray-3, #828282)",
                      fontFamily: "Open Sans",
                      fontSize: "20px",
                      fontStyle: "normal",
                      fontWeight: "700",
                      lineHeight: "180%",
                    }}
                  >
                    <NumberFormat
                      prefix={"Rp "}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      displayType="text"
                      value={data?.price}
                    />
                  </h3>
                )}
              </div>
            </div>
            <div>
              <h3
                style={{
                  color: "var(--Mono-Black, var(--text, #2D2D2D))",
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: "600",
                  lineHeight: "180%",
                }}
              >
                Deskripsi:
              </h3>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  color: "#8d8d8d",
                  marginBottom: "30px",
                  overflowWrap: "break-word",
                  lineHeight: "2",
                }}
                dangerouslySetInnerHTML={{ __html: data?.descriptionDetail }}
              />
            </div>
          </div>
          <div>
            <button onClick={onHide} className="btn font-weight-bold">
              <i className="ki ki-bold-close icon-md"></i>
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              if (users !== null)
                return history.push(`/client/create-brief/${data.id}`);
              return history.push("/login");
            }}
          >
            PESAN
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default VerticallyCenteredModal;
